import { colors } from '../../setup/theme';

export function parseHtml(html: string, variables?: Variables) {
    // Prepare html
    html = html.trim();

    // Parse variables
    if (variables) {
        html = parseVariables(html, variables);
    }

    // Parse colors
    Object.keys(colors).forEach(color => {
        html = html.replaceAll(`<${color}>`, `<span class="text-${color}">`).replaceAll(`</${color}>`, `</span>`);
    });

    return html;
}

export function parseVariables(html: string, variables: Variables) {
    // Get variables
    const vars = Object.entries(variables);
    if (vars.length) {
        // Parse variables
        const keys = vars.map(([key, value]) => {
            html = html.replaceAll(`{${key}}`, value);
            return key;
        });

        // Check new html for variables
        if (html.includes('{') && new RegExp(`{(${keys.join('|')})}`).exec(html)) {
            html = parseVariables(html, variables);
        }
    }

    return html;
}
